import Vue from 'vue'

import '@/utils/socket.io'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(Element)

import vuedraggable from 'vuedraggable'
Vue.component('draggable', vuedraggable) // 修改表头顺序和控制显示隐藏

// dialog组件
import dElDialog from '@/components/dialog/index.vue'
Vue.component('dElDialog', dElDialog)

import '@/style/filter.styl'
import '@/style/btn-txt.styl'
import '@/style/common.styl'
import '@/style/iconfont.css'
import '@/style/operation-log.styl'
import '@/style/dialog.styl'

import nodeContent from '@/components/node/node.vue'
Vue.component('node-content', nodeContent) // 审批 --- 节点组件全局注册
import condition from '@/components/node/condition.vue'
Vue.component('condition', condition) // 审批 --- 条件组件全局注册

import subMenu from '@/components/submenu/index.vue'
Vue.component('sub-menu', subMenu) // 修改表头顺序和控制显示隐藏 二级导航

import CommonLog from '@/components/common-log/index.vue'
Vue.component('common-log', CommonLog)

import ApprovalCommon from '@/components/approvalCommon/index.vue'
Vue.component('approval-common', ApprovalCommon)

import RejectCommon from '@/components/rejectCommon/index.vue'
Vue.component('rejectCommon', RejectCommon)

import TransferCommon from '@/components/transferCommon/index.vue'
Vue.component('transferCommon', TransferCommon)

import AddSignCommon from '@/components/addSign/index.vue'
Vue.component('addSign', AddSignCommon)

import ApprovedDialog from '@/components/approvedDialog/index.vue'
Vue.component('approvedDialog', ApprovedDialog)

import Echart from 'echarts'
Vue.prototype.$echarts = Echart

import * as lodash from 'lodash'
Vue.prototype.$lodash = lodash

// 添加全局指令 显示input只能输入数字，包括小数
Vue.directive('enterNumber', {
    bind: function (el: HTMLInputElement) {
        el.addEventListener('input', (e) => {
            const target = e.target as HTMLInputElement
            const reg = /^[0-9]+\.?[0-9]{0,2}$/
            if (target.value) {
                if (!reg.test(target.value)) {
                    target.value = target.value.substring(0, target.value.length - 1);
                }
            }
        })
    }
})

/*
* 自定义指令： 防抖
* @param {el} 元素
* @param {binding} 触发的事件
*/

Vue.directive('buttonDebounce', {
    inserted: function (el: HTMLElement, binding) {
        let timer
        el.addEventListener('click', () => {
            if (timer) {
                clearTimeout(timer)
            }
            timer = setTimeout(() => {
                binding.value()
            }, 1000)
        })
    }
})

// Vue.directive('el-select-loadmore', { // 指令懒加载
//     // bind表示这个自定义指令一绑定到dom上，就开始自动执行
//     bind(el:any, binding:any) {
//         // 获取element-ui定义好的scroll盒子
//         const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
//         SELECTWRAP_DOM.addEventListener('scroll', function () {
//             /**
//             * scrollHeight 获取元素内容高度(只读)
//             * scrollTop 获取或者设置元素的偏移值,常用于, 计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
//             * clientHeight 读取元素的可见高度(只读)
//             * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
//             * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
//             */
//            console.log(el.scrollHeight,el.scrollTop ,el.clientHeight)
//         //    this.scrollHeight = el.scrollHeight
//         //    this.scrollTop = el.scrollTop
//             const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
//             if (condition) {
//                 binding.value();
//             }
//         });
//     },
//     // 表示dom插入到页面上的时候自动执行
//     // 这些函数都有两个参数，一个是el(使用自定义指令的元素), 一个是binding(记录自定义指令信息的对象)
//     inserted(el, binding) {
//       el.focus()
//     },
//     // 表示自定义指令后面的值更新的时候，自动执行
//     update() {
//       console.log(this.scrollHeight , this.scrollTop, '11');
//     }
//   })
